import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { CONTACT } from "@/data/content";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum" testId="impressum-page">
      <p className="text-zinc-500 text-sm">
        Offenlegung gemäß § 5 ECG, § 14 UGB und § 25 MedienG.
      </p>

      <LegalSection heading="Medieninhaber & Diensteanbieter">
        <p>
          inn&apos;spective — {CONTACT.founder}
          <br />
          {CONTACT.address}, Österreich
        </p>
      </LegalSection>

      <LegalSection heading="Kontakt">
        <p>
          E-Mail:{" "}
          <a href={`mailto:${CONTACT.email}`} className="brand-text font-medium">
            {CONTACT.email}
          </a>
          <br />
          Telefon:{" "}
          <a href={CONTACT.phoneHref} className="brand-text font-medium">
            {CONTACT.phone}
          </a>
        </p>
      </LegalSection>

      <LegalSection heading="Unternehmensgegenstand">
        <p>
          IT-Beratung und IT-Dienstleistungen: On-Premises-Infrastruktur,
          Cloud &amp; Microsoft 365 sowie IT-Security.
        </p>
      </LegalSection>

      <LegalSection heading="Unternehmensdaten">
        <p>
          UID-Nummer: ATU79258107
          <br />
          Mitglied der Wirtschaftskammer Tirol
          <br />
          Zuständige Behörde: Bezirkshauptmannschaft Innsbruck
          <br />
          Berufsrecht: Gewerbeordnung (GewO), abrufbar unter{" "}
          <a
            href="https://www.ris.bka.gv.at"
            target="_blank"
            rel="noopener noreferrer"
            className="brand-text font-medium"
          >
            ris.bka.gv.at
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection heading="Online-Streitbeilegung">
        <p>
          Verbraucher haben die Möglichkeit, Beschwerden an die
          Online-Streitbeilegungsplattform der EU zu richten:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            className="brand-text font-medium"
          >
            ec.europa.eu/consumers/odr
          </a>
          . Sie können Beschwerden auch an die oben angeführte E-Mail-Adresse
          richten.
        </p>
      </LegalSection>

      <LegalSection heading="Haftung für Inhalte dieser Website">
        <p>
          Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt
          erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der
          Inhalte kann jedoch keine Gewähr übernommen werden. Als
          Diensteanbieter bin ich für eigene Inhalte auf diesen Seiten nach den
          allgemeinen Gesetzen verantwortlich.
        </p>
      </LegalSection>

      <LegalSection heading="Urheberrecht">
        <p>
          Die auf dieser Website erstellten Inhalte und Werke unterliegen dem
          österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung,
          Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
          Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen
          Autors bzw. Erstellers.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
